@file:OptIn(InternalResourceApi::class)

package liquid_root.samples.shared.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem
import org.jetbrains.compose.resources.StringResource

private const val MD: String = "composeResources/liquid_root.samples.shared.generated.resources/"

@delegate:ResourceContentHash(1_654_429_013)
public val Res.string.clock_format: StringResource by lazy {
      StringResource("string:clock_format", "clock_format", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10, 40),
      ))
    }

@delegate:ResourceContentHash(-1_627_589_680)
public val Res.string.liquid_demos_platform: StringResource by lazy {
      StringResource("string:liquid_demos_platform", "liquid_demos_platform", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 51, 57),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainString0Resources(map: MutableMap<String, StringResource>) {
  map.put("clock_format", Res.string.clock_format)
  map.put("liquid_demos_platform", Res.string.liquid_demos_platform)
}
